var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-table text-center"},[(_vm.response)?_c('div',{staticClass:"text-red"},[_c('p',[_vm._v(_vm._s(_vm.response))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"middle"},[_c('a',{attrs:{"id":"signin-button"},on:{"click":_vm.signIn}},[_vm._v("\n      Sign in with Google\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ba54c1d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 489
// module chunks = 1